import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card).withConfig({
  shouldForwardProp: (prop) => prop !== 'hasBorder' && prop !== 'lineTitleColor' && prop !== 'paddingHeader',
})<{
  lineTitleColor?: string;
  paddingHeader?: string;
  hasBorder?: boolean;
}>`
  position: relative;
  border-radius: ${({ theme }) => theme.cardRadius};
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.text.primary};
  border: ${({ hasBorder }) =>
    hasBorder ? '1px solid rgba(213, 217, 222, 1)' : 'none'};

  & .ant-card-head-title {
    font-size: 18px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: rgba(35, 40, 46, 1);
  }

  & > .ant-card-head {
    min-height: 40px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    border-bottom: 0 none;
    margin-bottom: 0;
    ${({ paddingHeader }) =>
      paddingHeader && `padding: ${paddingHeader} !important;`}

    & .ant-card-head-wrapper {
      min-height: 40px;
      &::before {
        content: '';
        width: 16px;
        height: 24px;
        margin-right: 16px;
        border-radius: 4px;
        background-color: ${({ lineTitleColor }) =>
          lineTitleColor || '#04533F'};
      }
    }
    & .ant-card-head-title {
      line-height: 26px;
    }

    & .ant-card-extra {
      padding: 0;

      & a {
        color: ${({ theme }) => theme.palette.secondary.main};
      }
    }
  }

  & > .ant-card-body {
    flex: 0 1 auto;
    padding: 0;
  }

  .ant-card-bordered {
    border: 0;
  }

  &.heightFull {
    height: 100%;

    & .ant-card-body {
      flex: 1;
    }
  }

  & .ant-card-actions {
    background-color: transparent;
    padding-top: 16px !important;
  }

  &.no-card-space {
    & .ant-card-body {
      padding: 0;
    }
  }

  &.no-card-space-ltr-rtl {
    & .ant-card-body {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;
